import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import styled from'styled-components';var ScreenReaderOnlyComponent = function ScreenReaderOnlyComponent(props) {
  var focusElementRef = props.focusElementRef,
    children = props.children,
    otherProps = _objectWithoutProperties(props, ["focusElementRef", "children"]);
  var ScreenReaderOnly = /*#__PURE__*/styled.span.withConfig({
    displayName: "ScreenReaderOnlyComponent__ScreenReaderOnly",
    componentId: "tgpitn-0"
  })(["clip:rect(0px,0px,0px,0px);height:1px;position:absolute;white-space:nowrap;width:1px;border-width:0px;margin:-1px;overflow:hidden;padding:0px;"]);
  return /*#__PURE__*/React.createElement(ScreenReaderOnly, _extends({
    ref: focusElementRef
  }, otherProps), children);
};
process.env.NODE_ENV !== "production" ? ScreenReaderOnlyComponent.propTypes = {
  children: PropTypes.node,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })])
} : void 0;
ScreenReaderOnlyComponent.defaultProps = {
  children: null,
  focusElementRef: null
};
var ScreenReaderOnlyComponent$1 = ScreenReaderOnlyComponent;export{ScreenReaderOnlyComponent$1 as default};